function getRootNode(node) {
  if (!node) {
    return null;
  }
  if (node === document || node === document.documentElement || node === document.body || node.parentNode === document.body) {
    return node;
  }
  return getRootNode(node.parentNode);
}
export {
  getRootNode
};
